import { Box, Paper } from '@mui/material';
import { useState } from 'react';
import { usePageTitle } from '@/hooks/usePageTitle';
import { BulkUploadWizard } from './components/BulkUploadWizard';
import { BulkUploadData, WizardStep } from './types';

export const MetadataBulkUploadPage = () => {
  const [currentStep, setCurrentStep] = useState<WizardStep>(WizardStep.FILE_UPLOAD);
  const [bulkUploadData, setBulkUploadData] = useState<BulkUploadData | undefined>();

  usePageTitle('Metadata Upload');

  const handleStepChange = (step: WizardStep) => {
    setCurrentStep(step);
  };

  const handleDataChange = (data: BulkUploadData) => {
    setBulkUploadData(data);
  };

  const handleReset = () => {
    setCurrentStep(WizardStep.FILE_UPLOAD);
    setBulkUploadData(undefined);
  };

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
        alignItems: 'center',
      }}
    >
      <Paper
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          minHeight: 0,
          padding: '24px',
          width: '100%',
          maxWidth: '1500px',
        }}
        elevation={1}
      >
        <BulkUploadWizard
          currentStep={currentStep}
          bulkUploadData={bulkUploadData}
          onStepChange={handleStepChange}
          onDataChange={handleDataChange}
          onReset={handleReset}
        />
      </Paper>
    </Box>
  );
};
